<ion-app>
  <ion-router-outlet #routerOutlet></ion-router-outlet>
</ion-app>
